import $ from 'jquery';

$( document ).ready(function() {
	$('.canned_message_wrapper a').on('click', function(event) {
		event.preventDefault();
		
		$('.canned_message_wrapper').css("color", "black");
    	var canned_message_wrapper = $(this).parent(".canned_message_wrapper");
    	canned_message_wrapper.css("color", "green");
    	var canned_message_content = $(canned_message_wrapper).find(".canned_message_content").html();

    	var target_elem = $('.announcement_description');
    	target_elem.html(canned_message_content);
	});
});
